import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"face-retouching"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M2.27515 9.66054C2.09527 10.411 2 11.1944 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C11.3097 2 10.6357 2.06995 9.98469 2.20316M14.4762 14.5469C13.9911 15.4133 13.0644 15.9989 12.0008 15.9989C10.9372 15.9989 10.0105 15.4133 9.52539 14.5469M8.46289 9.93457H8.4668V9.93848H8.46289V9.93457ZM15.5122 9.93359H15.5161V9.9375H15.5122V9.93359Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M4.25 3L4.66543 3.83457L5.5 4.25L4.66543 4.66543L4.25 5.5L3.83457 4.66543L3 4.25L3.83457 3.83457L4.25 3Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M21.625 21.5L21.6665 21.5835L21.75 21.625L21.6665 21.6665L21.625 21.75L21.5835 21.6665L21.5 21.625L21.5835 21.5835L21.625 21.5Z","strokeWidth":"props.strokeWidth"}}]}]}]};

const FaceRetouching = Vue.extend<IconProps>({
  name: 'FaceRetouchingIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'face-retouching',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default FaceRetouching;
